<template>
  <v-autocomplete
    v-model="shopId"
    :items="shopList"
    :loading="shopLoading"
    :search-input.sync="search"
    hide-no-data
    item-text="name"
    item-value="id"
    label="Select Shop"
    placeholder="Type Shop Name/Code"
    :filter="shopFilter"
    @input="setShop"
    clearable
  >
    <template v-slot:item="data">
      <v-list-tile-content
        v-html="data.item.name + '/' + data.item.code"
      ></v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";

export default {
  name: "ShopAutocomplete",

  props: {
    param: Number,
  },

  data: () => ({
    shopList: [],
    shopLoading: false,
    search: null,
  }),

  computed: {
    shopId: {
      get() {
        return this.param;
      },
      set() {
        //
      },
    },
  },

  watch: {
    search(val) {
      this.getShopList(val);
    },
  },

  methods: {
    shopFilter(item, queryText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },

    getShopList(val) {
      if (val) {
        if (val.length > 3) {
          this.shopLoading = true;
          let params = {
            nameCode: val,
          };

          shopService
            .getShopByNameCode(params)
            .then((res) => {
              this.shopList = res.data;
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.shopLoading = false;
            });
        }
      }
    },

    setShop(shopId) {
      var shopName = "";
      var shopCode = "";
      if (shopId) {
        let shop = commonService.search("id", shopId, this.shopList);
        if (shop) {
          shopName = shop.name;
          shopCode = shop.code;
        }
      }
      let obj = {
        shopId: shopId,
        shopName: shopName,
        shopCode: shopCode,
      };
      this.$emit("set", obj);
    },
  },
};
</script>